<template>
	<div class="content animated fadeIn">
		<div class="top-tab-row">
			<span class="top-tab"
				@click="handleToogleTab('应用中心')"
				:class="activeTab=='应用中心'?'active':''">
				应用中心
				<div class="devider"></div>
			</span>
			<span class="top-tab"
				@click="handleToogleTab('办事大厅')"
				:class="activeTab=='办事大厅'?'active':''">
				办事大厅
				<div class="devider"></div>
			</span>
			<img src="../assets/images/search_b.png"
				@click="search"
				alt="">
		</div>
		<div class="main-wrap">
			<!-- 常用服务 -->
			<div class="cyfw">
				<div class="title-row">{{cyTitle}}</div>
				<ul class="app-list">
					<li @click="operationWyy(item.appId,item.appUrl)"
						:key="index"
						v-for="(item,index) in cyAppList">
            <div class="img">
              <img class="app-logo" :src="item.appImages"
							alt="">
              <img v-if="item.appIntranet==1" src="../assets/images/nei_icon.png" class="school" alt="">
            </div>
						<span class="app-name">{{item.appName}}</span>
					</li>
				</ul>
			</div>
			<!-- 应用中心其他分类 -->
			<div class="yyqt">
				<van-tabs v-model="active">
					<van-tab :title="item1.title"
            :key="item1.title"
						v-for="item1 in cateAppList">
						<ul class="app-list">
							<li :key="item2.appId"
                @click="operationWyy(item2.appId,item2.appUrl)"
								v-for="item2 in item1.apps">
								<div class="img">
                  <img class="app-logo" :src="item2.appImages"
                  alt="">
                  <img v-if="item2.appIntranet==1" src="../assets/images/nei_icon.png" class="school" alt="">
                </div>
								<span class="app-name">{{item2.appName}}</span>
							</li>
						</ul>
					</van-tab>
					<!-- <van-tab title="标签2">内容 2</van-tab> -->
				</van-tabs>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { Toast } from "vant";
export default {
  computed: {
    ...mapState(["memberInfo", "roleList"]),
  },
  data() {
    return {
      memberAppList: [],
      recordApp: [],
      collectionList: [],
      active: "我的收藏",
      mainState: false,
      active: 0,
      activeTab: "应用中心",
      // 常用应用列表数据
      cyAppList: [],
      // 应用分类列表数据
      cateAppList: [],
      // 常用服务或常用办事
      cyTitle:''
    };
  },
  mounted() {
    this.getMemberApp();
    // this.findCollectionAppList();
    let activeTabCy=sessionStorage.getItem('activeName')
    if(activeTabCy=='办事服务'){
      this.activeTab='办事大厅'
    }
  },
  methods: {
    /**
     * @name handleToogleTab
     * @description 切换顶部tab
     * @param {val:切换项标题}
     * @author hll
     * @date 2021-05-28 14:10:10
     */
    handleToogleTab(val) {
      this.activeTab = val;
      this.getShowData(JSON.parse(this.memberAppList))
    },
    // 点击搜索按钮进入搜素页面
    search() {
      this.$router.push("/search");
    },
    operationWyy(id, url) {
      this.$common.appAccessStatistical(id);
      if (url == "http://" || url == "https://") {
        Toast("系统建设中，敬请期待！");
      } else {
        location.href = url;
      }
    },
    getMemberApp() {
      this.$axios({
        method: "post",
        url: baseUrl + "/app/memberApp/getMemberApp",
        data: this.qs.stringify({
          roleList: JSON.stringify(this.roleList),
        }),
      })
        .then(async (res) => {
          if (res.success) {
            this.memberAppList=JSON.stringify(res.obj)
            this.getShowData(res.obj)
          }
        })
        .catch((error) => {});
    },
    // 处理当前要展示的列表数据
    async getShowData(listVal){
      let cyList = [];
      let cateList = [];
      for (var i = 0; i < listVal.length; i++) {
        if (this.activeTab == "应用中心") {
          if (listVal[i].modulesCode == "yyzx_cyfw") {
            cyList.push(listVal[i]);
            this.cyTitle=listVal[i].modulesName
          } else if (listVal[i].modulesCode.indexOf("yyzx") != -1) {
            cateList.push(listVal[i]);
          }
        } else {
          // 如果当前tab为办事大厅
          if (listVal[i].modulesCode == "bsdt_cybs") {
            cyList.push(listVal[i]);
            this.cyTitle=listVal[i].modulesName
          }else if (listVal[i].modulesCode.indexOf("bsdt") != -1) {
            cateList.push(listVal[i]);
          }
        }
      }

      this.cyAppList = await this.$common.setMemberAppData(cyList);
      this.cateAppList = await this.$common.setMemberAppData(
        cateList,
        "cate-list"
      );
    },

    //查询收藏的应用
    // findCollectionAppList() {
    //   this.$axios({
    //     url: baseUrl + "/app/collectionApp/findCollectionAppList",
    //     method: "POST",
    //   }).then(
    //     (res) => {
    //       if (res.success) {
    //         this.setCollectData(res);
    //       }
    //     },
    //     (error) => {}
    //   );
    // },
    // setCollectData(res) {
    //   for (let i = 0; i < res.obj.length; i++) {
    //     if (
    //       res.obj[i].appUrl != null &&
    //       res.obj[i].appUrl != "" &&
    //       this.memberInfo != ""
    //     ) {
    //       res.obj[i].appUrl = res.obj[i].appUrl.replace(
    //         "{memberid}",
    //         this.memberInfo.memberUsername
    //       );
    //       if (res.obj[i].appUrl.indexOf("{memberAesEncrypt}") > -1) {
    //         res.obj[i].appUrl = res.obj[i].appUrl.replace(
    //           "{memberAesEncrypt}",
    //           this.$common.getSecretKey(res.obj[i].appId)
    //         );
    //       }
    //       res.obj[i].appUrl = res.obj[i].appUrl.replace(
    //         "{quicklyTicket}",
    //         this.memberInfo.quicklyTicket
    //       );
    //     }
    //     if (res.obj[i].portalAppIcon != null) {
    //       res.obj[i].appImages =
    //         baseUrl +
    //         "/public/getImg?path=" +
    //         encodeURI(res.obj[i].portalAppIcon.templetAppImage);
    //     } else {
    //       res.obj[i].appImages =
    //         baseUrl + "/public/getImg?path=" + encodeURI(res.obj[i].appImages);
    //     }
    //   }
    //   this.collectionList = res.obj;
    // },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  height: calc(100% - 1.2rem);
  background: #fafbff;
  .top-tab-row {
    width: 100%;
    height: 1.4rem;
    background-image: url(../assets/images/top_bg.png);
    background-size: 100% 100%;
    padding-top: 0.27rem;
    box-sizing: border-box;
    position: relative;
    text-align: center;
    display: flex;
    justify-content: center;
    span.top-tab {
      font-size: 0.26rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding: 0 0.21rem;
      padding-top: 0.38rem;
      .devider {
        display: none;
      }
    }
    span.top-tab.active {
      font-size: 0.32rem;
      font-weight: 500;
      color: #ffffff;
      padding-top: 0.35rem;
      .devider {
        display: block;
        width: 0.4rem;
        height: 0.06rem;
        background: #ffffff;
        border-radius: 0.03rem;
        margin: 0 auto;
        margin-top: 0.16rem;
      }
    }
    img {
      width: 0.4rem;
      height: 0.4rem;
      position: absolute;
      top: 0.7rem;
      right: 0.25rem;
    }
  }
}
.main-wrap {
  width: 100%;
  height: calc(100% - 1.4rem);
  overflow-y: auto;
}
.main-wrap::-webkit-scrollbar {
  display: none !important;
  width: 0px;
  height: 0px;
}
.cyfw {
  margin: 0.24rem 0.23rem;
  padding: 0.35rem 0.32rem 0 0.32rem;
  background: #ffffff;
  border-radius: 0.2rem;
  .title-row {
    font-size: 0.32rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #282828;
  }
}
.app-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.4rem;
  li {
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.26rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #555555;
    margin-bottom: 0.38rem;

    .img {
      position: relative;
      .app-logo{
        width: 0.765rem;
        height: 0.76rem;
      }
      .school{
        width:.3rem;
        height: .3rem;
        position: absolute;
        top:0;
        right: -.12rem;
      }
      margin-bottom: 0.17rem;
    }
    .app-name {
      // display: inline-block;
      display:-webkit-box;
      width: 1.43rem;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3; // 控制多行的行数
      -webkit-box-orient: vertical;
    }
  }
}
.yyqt {
  margin: 0.24rem 0.23rem;
  padding: 0 0.32rem 0 0.32rem;
  background: #ffffff;
  border-radius: 0.2rem;
}
.yyqt /deep/ .van-tabs__wrap {
  margin-left: -0.2rem;
}
.yyqt /deep/.van-tab {
  width: auto;
  flex: none;
  padding: 0 0.2rem;
  font-size: 0.26rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.yyqt /deep/ .van-tabs__line {
  width: 0.4rem;
  height: 0.06rem;
  background: #0073fa;
  border-radius: 0.03rem;
}
.yyqt /deep/ .van-tab--active {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #282828;
}
</style>
